import * as React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { ApiClient } from "../../../lib/api";
import { Page } from "../../../lib/model/Page";
import { MainComponentContainer } from "../../../shared/MainComponentContainer";
import { PagedList } from "../../../shared/PagedList";
import { RootState } from "../../../store/rootReducer";
import { Address } from "../../../lib/model/Address";
import { AddressCell } from "./AddressCell";
import { Row, Col } from "antd";
import styled from "styled-components";
import { ListItem } from "../../../lib/model/ListItem";

type TitleProps = {
  paddingLeft: number;
};

const Wrapper = styled.div`
  padding: 50px;
  overflow: auto;

  @media only screen and (max-width: 575px) {
    padding: 10px;
  }
`;

const Title = styled.div`
  font-size: 11px;
  font-weight: 300;
  color: #061a32;
  padding: 7px 0;
  padding-left: ${(props: TitleProps) => props.paddingLeft}px;
  background-color: #f7f7f7;
  width: 100%;
`;

const client = new ApiClient();

const loadData = (after?: string): Promise<Page<Address>> => {
  return client.fetchAddresses(after);
};

type State = {};

const mapStateToProps = (state: RootState) => ({});

const dispatchProps = {
  push
};

type Props = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

class AddressesContainer extends React.Component<Props, State> {
  readonly state: State = {};
  render = () => {
    return (
      <MainComponentContainer>
        <Wrapper>
          <Row type="flex" gutter={1} style={{ marginBottom: 30 }}>
            <Col span={7}>
              <Title paddingLeft={23}>Firmenname</Title>
            </Col>
            <Col span={6}>
              <Title paddingLeft={30}>Adresse</Title>
            </Col>
            <Col span={6}>
              <Title paddingLeft={30}>Kontakt</Title>
            </Col>
            <Col span={5}>
              <Title paddingLeft={30}>Info</Title>
            </Col>
          </Row>
          <PagedList loadData={loadData} renderItem={this.renderItem} />
        </Wrapper>
      </MainComponentContainer>
    );
  };
  renderItem = (item: ListItem<Address>): React.ReactElement => {
    return (
      <AddressCell isPlaceholder={item.isPlaceholder} address={item.item} />
    );
  };
}

export default connect(
  mapStateToProps,
  dispatchProps
)(AddressesContainer);
